/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import { ValueUpdateDetail } from '../utils/UNSAFE_valueUpdateDetail';

type RadioSetContextValue = {
  name: string;
  value?: string | number;
  onCommit?: (detail: ValueUpdateDetail<string | number | undefined>) => void;
  setFocusIndex?: (value: number) => void; // used for readonly keyboard navigation
};

const RadioSetContext = createContext<RadioSetContextValue>({} as RadioSetContextValue);
const useRadioSetContext = () => useContext(RadioSetContext);

export { RadioSetContext, useRadioSetContext };
